import React, { useState } from "react";
import styled from "styled-components";
import mortgageOne from "../assets/images/mortgage-one.png";
import mortgagetwo from "../assets/images/mortgage-two.png";
import mortgagethree from "../assets/images/mortgage-three.png";
import mortgagefour from "../assets/images/mortgage-four.png";

const steps = [
  {
    title: "Speak to a mortgage expert",
    description: "We take time to understand your home buying goals and financial needs to identify the best mortgage options for you.",
    image: mortgageOne,
  },
  {
    title: "Complete your application",
    description:
      "Our first goal is to get your pre-approved. Teamwork makes the dreamwork -- you send in your documents, we prepare your application.",
    image: mortgagetwo,
  },
  {
    title: "Match it with a property",
    description: "If you haven’t identified a property yet, your mortgage consultant can connect you to our in-house real estate team.",
    image: mortgagethree,
  },
  {
    title: "Finalize your mortgage",
    description: "Sign the final offer letter and receive your mortgage from the bank.",
    image: mortgagefour,
  },
];

const StepFlow = () => {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <Container>
      <Steps>
        {steps.map((step, index) => (
          <StepItem
            key={index}
            active={index === activeStep}
            onClick={() => setActiveStep(index)}
          >
            <CircleWrapper>
              <Circle active={index === activeStep}>{index + 1}</Circle>
              {index < steps.length - 1 && <Line />}
            </CircleWrapper>
            <StepText>
              <Title active={index === activeStep}>{step.title}</Title>
              {index === activeStep && (
                <Description>{step.description}</Description>
              )}
            </StepText>
          </StepItem>
        ))}
      </Steps>

      <ImageSection>
        <Image src={steps[activeStep].image} alt="Step visual" />
      </ImageSection>
    </Container>
  );
};

export default StepFlow;
const Container = styled.div`
  display: flex;
  padding: 2rem;
  background: #f8f8f8;
  border-radius: 20px;
  gap: 40px;
  margin-top: 3rem;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 1rem;
    padding: 1rem;
  }
`;

const Steps = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 30px;
`;

const StepItem = styled.div`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
`;

const CircleWrapper = styled.div`
  position: relative;
  margin-right: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Circle = styled.div`
  width: ${(props) => (props.active ? "40px" : "32px")};
  height: ${(props) => (props.active ? "40px" : "32px")};
  border-radius: 50%;
  background: ${(props) => (props.active ? "#000" : "#a78c4c")};
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
`;

const Line = styled.div`
  width: 2px;
  flex-grow: 1;
  background: #ccc;
  margin-top: 8px;
`;

const StepText = styled.div``;

const Title = styled.h3`
  font-size: 20px;
  color: ${(props) => (props.active ? "#000" : "#555")};
  margin: 0;
`;

const Description = styled.p`
  margin: 8px 0 0;
  color: #333;
  font-size: 16px;
`;

const ImageSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Image = styled.img`
  width: 100%;
  border-radius: 16px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;
